module.exports = __webpack_public_path__ + "static/Janowo_Park_III_ujecie_04-9c7ac854cb9243236b74b9fb46dd58b1.jpg";